export enum TicketCardFlowType {
  REG_GET_TICKET = "REG_GET_TICKET",
  REG_BULK_TICKET = "REG_BULK_TICKET",
  UPGRADE_TICKET = "UPGRADE_TICKET",
  MY_EXP_GET_TICKET = "MY_EXP_GET_TICKET"
}
